export const KONTRA_BLUE = '#1890FF';
export const KONTRA_BLUE_LIGHT = "#6EC0FF";
export const KONTRA_BLUE_LIGHT_DISABLED = "#6EC0FFA0";

export const KONTRA_RED = '#FF5131';
export const KONTRA_GREEN = '#5EFC82';

export const BLACK = '#000000DE';
export const BLACK_SECONDARY = '#00000099';
export const BLACK_DISABLED = '#0000001E';

export const WHITE = '#FFFFFFDE';
export const WHITE_SECONDARY = '#FFFFFF99';
export const WHITE_DISABLED = '#FFFFFF1E';

export const markers = {
  property: {
    SELECTED: 'rebeccapurple',
    NO_SERVICE: 'seagreen',
    LOW_PRIORITY: KONTRA_BLUE,
    MEDIUM_PRIORITY: 'orangered',
    HIGH_PRIORITY: 'crimson'
  },
  user: {
    DEFAULT: '#121212',
    SELECTED: 'rebeccapurple'
  }
};

export const directions = {
  polyline: KONTRA_BLUE
};

export const shifts = {
  PUBLISHED: '#FFA726',
  ACKNOWLEDGED: KONTRA_BLUE,
  UNPUBLISHED: '#F06292'
};

export const geofence = {
  LINE: 'rgb(0,255,127)',
  FILL: 'rgba(0,255,127,.15)',
  DAR_LINE: "#6EC0FF",
  DAR_FILL: "#6EC0FF1E"
};